import { LocalizedText, LocalizedElement, sourceAttribute, useSourceLanguage } from "../i18n/LocalizedCopy";
import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";

export default function ChatImageLightbox({ src, onClose }) {
  useSourceLanguage();
  const closeRef = useRef(null);
  useEffect(() => {
    const previousFocus = document.activeElement;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    closeRef.current?.focus();
    const onKeyDown = event => {
      if (event.key === "Escape") { event.preventDefault(); event.stopImmediatePropagation(); onClose(); }
      if (event.key === "Tab") { event.preventDefault(); closeRef.current?.focus(); }
    };
    document.addEventListener("keydown", onKeyDown, true);
    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener("keydown", onKeyDown, true);
      previousFocus?.focus?.();
    };
  }, [onClose]);
  return createPortal(
    <LocalizedElement elementType={"div"} copyAttributes={["aria-label"]} className="chat-image-lightbox" role="dialog" aria-modal="true" aria-label={sourceAttribute("Image en plein écran")} onClick={onClose}>
      <button ref={closeRef} type="button" className="chat-image-lightbox__close" onClick={onClose}><LocalizedText source={"Fermer l’image ×"} /></button>
      <LocalizedElement elementType={"img"} copyAttributes={["alt"]} src={src} alt={sourceAttribute("Aperçu agrandi")} className="chat-image-lightbox__image" onClick={event => event.stopPropagation()} />
    </LocalizedElement>, document.body
  );
}
